import React from "react";
import logo from "../../assets/logo_ciano_50_bianco.png";
import toastStyles from "../../styles/Toast.module.css";
import menuStyles from "../../styles/Menu.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSignOutAlt,
  faHome,
} from "@fortawesome/free-solid-svg-icons"; // Importa le icone

import { AiFillHome, AiOutlineHome, AiOutlineLogout } from "react-icons/ai";
import { TiPlus, TiPlusOutline } from "react-icons/ti";

function Menu(props) {
  return (
    <div className="Menu">
      {/* Icona Home */}
      <button
        type="button"
        onClick={() => props.setMenu("show")}
        disabled={props.menu === "show"}
        title="Show Post"
        style={{
          backgroundColor: props.menu === "show" ? "#007bff" : "#007bff", // Colore di sfondo grigio se disabilitato
          cursor: props.menu === "show" ? "not-allowed" : "pointer", // Cambia il cursore se disabilitato
        }}
      >
        {/* Se vuoi usare l'icona di Font Awesome per Home */}
        {props.menu === "show" ? (
          <AiOutlineHome
            style={{
              color: "white",
              fontSize: "24px",
            }}
          />
        ) : (
          <AiFillHome
            style={{
              color: "white",
              fontSize: "24px",
            }}
          />
        )}
      </button>
      {/* Icona Create */}
      <button
        type="button"
        onClick={() => props.setMenu("create")}
        disabled={props.menu === "create"}
        title="Create Post"
        style={{
          backgroundColor: props.menu === "create" ? "#007bff" : "#007bff", // Colore di sfondo grigio se disabilitato
          cursor: props.menu === "create" ? "not-allowed" : "pointer", // Cambia il cursore se disabilitato
        }}
      >
        {props.menu === "show" ? (
          <TiPlus
            style={{
              color: "white",
              fontSize: "24px",
            }}
          />
        ) : (
          <TiPlusOutline
            style={{
              color: "white",
              fontSize: "24px",
            }}
          />
        )}
        {/* Icona per "Create" */}
      </button>
      <div className={toastStyles.menu}>
        <img src={logo} alt="" className={toastStyles.responsiveImage} />
        finstagram
      </div>
      {/* Icona LogOut */}
      <div className="logout">
        <button type="button" onClick={() => props.onLogOut()} title="Logout">
          <AiOutlineLogout
            style={{
              color: "white",
              fontSize: "24px",
            }}
          />{" "}
          {/* Icona per "LogOut" */}
          {/* LogOut */}
        </button>
      </div>
    </div>
  );
}

export default Menu;
